import {
  AdvancedFilterInputSchema,
  fulfillmentGroupFilterNames,
} from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import * as z from "zod/v4";

export const getFulfillmentGroupUniqueValues = {
  name: "getFulfillmentGroupUniqueValues" as const,
  input: AdvancedFilterInputSchema.extend({
    filterName: z.enum(fulfillmentGroupFilterNames),
    filterSearch: z.string().nullish(),
  }),
  output: z.object({ values: z.array(z.string()) }),
};
